import { useRef, useState } from 'react'
import io from "socket.io-client"



const useVideoChat = () => {

  const peerConnection = useRef();
  const refRTCSessionDescription = useRef();
  const refRTCPeerConnection = useRef();
  const refRTCIceCandidate = useRef();
  const refAudioOnStream = useRef(false);
  const refMyID = useRef();
  const socket = useRef();
  const refQrCodeDecoder = useRef();
  const refUtilsGetUserMedia = useRef();
  const refCallBackCallUser = useRef();
  const refCallBackEndCall = useRef();
  const refCallBackInitCall = useRef();
  const refOnAbleToReceiveCall = useRef();
  const refOnAbleToReconnect = useRef();
  const refOnAnswerReconnect = useRef();
  const refOnSocketDisconect = useRef();
  const refIsMobile = useRef(false);
  const refStorageLib = useRef(null);
  const [remoteStream, setRemoteStream] = useState();
  const [localStream, setLocalStream] = useState();
  const refLocalStream = useRef();
  const [mySocketID, setMySocketID] = useState();
  const [callingme, setCallingme] = useState();
  const refIdOther = useRef(0);
  const refQuemLiga = useRef();
  const refQuemRecebe = useRef();
  const dataCalling = useRef();
  const [inCall, setInCall] = useState(false);
  const [socketInstance, setSocketInstance] = useState(null);
  const [connectionState, setConnectionState] = useState(null);
  const remoteCandidatesQueue = useRef([]);
  const refEuQuemLigou = useRef(false);
  const refIsEndingCall = useRef(false);



  /**
   * @param objConfig = {
   *  _RTCSessionDescription, not null
   *  _RTCPeerConnection, not null
   *  _RTCIceCandidate, not null
   *  _QRCodeDecodeLibWeb null,
   *  _isMobile not null
   *  _utilsGetUserMedia onlyMobile is necessary,
   *  _token not null
   *  _socketAdress not null,
   *  _audioOnStream // only web. 
   *  _callBackCallUser
   *  _storageLib 
   *  _callBackEndCall
   *  _callBackInitCall
   *  _onAbleToReceiveCall
   *  _onAbleToReconnect
   *  _onAnswerReconnect
   *  _onSocketDisconect
   * }
   */
  async function bootstrap(objConfig) {
    if (socket.current) return;

    const {
      _onSocketDisconect,
      _onAbleToReconnect,
      _onAnswerReconnect,
      _onAbleToReceiveCall,
      _callBackInitCall,
      _callBackEndCall,
      _storageLib,
      _callBackCallUser,
      _RTCSessionDescription,
      _RTCPeerConnection,
      _RTCIceCandidate,
      _QRCodeDecodeLibWeb,
      _utilsGetUserMedia,
      isMobile,
      _token,
      _socketAdress,
      _audioOnStream
    } = objConfig;

    refRTCSessionDescription.current = _RTCSessionDescription;
    refRTCPeerConnection.current = _RTCPeerConnection;
    refRTCIceCandidate.current = _RTCIceCandidate;
    refIsMobile.current = isMobile;
    refCallBackCallUser.current = _callBackCallUser

    if (_audioOnStream) refAudioOnStream.current = true
    if (_callBackEndCall) refCallBackEndCall.current = _callBackEndCall;
    if (_callBackInitCall) refCallBackInitCall.current = _callBackInitCall;

    if (_utilsGetUserMedia) refUtilsGetUserMedia.current = _utilsGetUserMedia;
    if (_QRCodeDecodeLibWeb) refQrCodeDecoder.current = _QRCodeDecodeLibWeb;
    if (_onAbleToReceiveCall) refOnAbleToReceiveCall.current = _onAbleToReceiveCall;
    if (_onAbleToReconnect) refOnAbleToReconnect.current = _onAbleToReconnect;
    if (_onAnswerReconnect) refOnAnswerReconnect.current = _onAnswerReconnect;
    if (_storageLib) refStorageLib.current = _storageLib;
    if (_onSocketDisconect) refOnSocketDisconect.current = _onSocketDisconect;



    socket.current = io(_socketAdress, {
      query: { token: _token },
      reconnectionDelay: 3000,
      reconnection: true,
      reconnectionAttempts: Infinity,
    });

    //Socket events
    socket.current.on("me", (id) => {
      setMySocketID(id);
      refMyID.current = id;
    });


    socket.current.on("callUser", (data) => {
      handleCallUserEvent(data)
    })


    socket.current.on("callWasRefuse", () => {
      refuseCall()
    })


    socket.current.on("ice-candidate", (data) => {
      addCandidate(data)
    })

    socket.current.on("endCall", (data) => {
      endCall(false);
    })


    socket.current.on("callAccepted", (data) => {
      callAnswerd(data)
    })

    socket.current.on("ableToReceiveCall", (data) => {
      if (refOnAbleToReceiveCall.current) {
        refOnAbleToReceiveCall.current(data);
      }
    })


    socket.current.on("ableToReconnect", (data) => {
      if (refOnAbleToReconnect.current) {
        refOnAbleToReconnect.current(data);
      }
    })


    socket.current.on("answerReconnect", (data) => {
      if (refOnAnswerReconnect.current) {
        refOnAnswerReconnect.current(data);
      }
    })


    socket.current.on("disconnect", () => {
      console.log('desconectou o socket')
      if (refIsMobile.current) return;
      if (peerConnection.current) peerConnection.current.close();
      peerConnection.current = null;
      cleanStreams();
      setRemoteStream(null);
      setLocalStream(null);
      setInCall(false);
      setConnectionState(null);
    });


    setSocketInstance(socket.current);
  }



  async function configFramesAndWebrtc() {
    try {
      cleanStreams();
      let _stream = null;
      if (!refIsMobile.current) {
        _stream = await navigator.mediaDevices.getUserMedia({
          video: {
            frameRate: 60,
            facingMode: 'user'
          }, audio: refAudioOnStream.current
        });
      }
      else {
        _stream = await refUtilsGetUserMedia.current();
      }
      setLocalStream(_stream);
      refLocalStream.current = _stream;
      configWebRTC(_stream);
    } catch (error) {
      console.log(error)
    }
  }



  function configWebRTC(_streamParamter) {
    try {
      if (peerConnection.current) {
        peerConnection.current.close();
        peerConnection.current = null;
      }

      const configuration = {
        iceServers: [
          { urls: 'stun:turn.appgrupohk.com.br:3478' },
          {
            urls: [
              'turn:turn.appgrupohk.com.br:3478?transport=udp',
              'turn:turn.appgrupohk.com.br:3478?transport=tcp',
              'turns:turn.appgrupohk.com.br:5349?transport=tcp',
            ],
            username: 'test',
            credential: 'test123',
          },
        ],
        iceTransportPolicy: 'all',
        iceCandidatePoolSize: 0,
        rtcpMuxPolicy: 'negotiate'
      };

      peerConnection.current = new refRTCPeerConnection.current(configuration);


      if (_streamParamter) {
        _streamParamter.getTracks().forEach(track => {
          peerConnection.current.addTrack(track, _streamParamter);
        });
      }

      peerConnection.current.ontrack = (event) => {
        if (event.streams && event.streams[0]) {
          setRemoteStream(event.streams[0]);
        }
      };


      peerConnection.current.onicecandidate = async (event) => {
        if (event.candidate) {
          const to = refEuQuemLigou.current
            ? refQuemLiga.current
            : refQuemRecebe.current;
          socket.current.emit('ice-candidate', {
            to: to,
            candidate: event.candidate
          });
        }
      }


      peerConnection.current.addEventListener('connectionstatechange', event => {
        const state = peerConnection.current?.connectionState;

        setConnectionState(state);

        if (state === 'connected') {
          setInCall(true);
        }

        console.log('[WebRTC] connectionState:', state);
      });

      peerConnection.current.addEventListener('iceconnectionstatechange', () => {
        console.log('[WebRTC] iceConnectionState:', peerConnection.current && peerConnection.current.iceConnectionState);
      });

    } catch (error) {
      throw new Error('Erro ao configurar webRTC ' + error)
    }
  }



  async function callUser(idToCallParam) {
    try {
      if (!peerConnection.current || peerConnection.current.connectionState === 'closed') {
        await configFramesAndWebrtc();
      }

      if (peerConnection.current) {
        refEuQuemLigou.current = true;


        const offer = await peerConnection.current.createOffer({
          offerToReceiveAudio: refAudioOnStream.current,
          offerToReceiveVideo: true,
          voiceActivityDetection: true
        })

        await peerConnection.current.setLocalDescription(offer);

        refQuemLiga.current = idToCallParam;

        refIdOther.current = idToCallParam;


        socket.current.emit("callUser", {
          userToCall: idToCallParam,
          offer: offer,
          from: refMyID.current
        })
      }
    } catch (error) {
      console.log(`callUser: ${error}`)
    }
  }



  async function handleCallUserEvent(data) {
    refQuemRecebe.current = data.from;

    refIdOther.current = data.from;


    dataCalling.current = data;
    setCallingme(true);
    if (refIsMobile.current && refStorageLib.current) {
      try {
        data.date = new Date();
        const str = JSON.stringify(data);
        refStorageLib.current.setItem('@offer', str.toString());

      } catch (error) {
        throw new Error(`Erro ao salvar offer no asyncStorage. ${error}`)
      }
      if (refCallBackCallUser.current) {
        refCallBackCallUser.current(data.from);
      }
      if (refIsMobile.current) {

        acceptACall();

      }
    }
  }



  async function addCandidate(data) {
    if (!data?.candidate) return;

    const ice = new refRTCIceCandidate.current(data.candidate);
    try {

      if (!peerConnection.current || !peerConnection.current.remoteDescription) {
        if (remoteCandidatesQueue.current.length < 50) {
          remoteCandidatesQueue.current.push(ice);
        }
        return;
      }

      await peerConnection.current.addIceCandidate(ice);
    } catch (error) {
      if (remoteCandidatesQueue.current.length < 50) {
        remoteCandidatesQueue.current.push(ice);
      }
      console.log(`Error AddCandidate: [${error}]`)
    }
  }



  function cleanStreams() {
    if (refLocalStream.current) {
      refLocalStream.current.getTracks().forEach(function (track) {
        track.stop();
      });
    }
  }



  function refuseCall() {
    try {
      if (peerConnection.current) peerConnection.current.close();

      cleanStreams();
      setRemoteStream(null);
      refEuQuemLigou.current = false;
      setLocalStream(null);
      setInCall(false);
      setCallingme(false);
      setConnectionState(null);
      socket.current.emit('callWasRefuse', {
        to: refQuemRecebe.current
      });
    } catch (error) {
      throw new Error('refuseCall: ' + error)
    }
  }



  function endCall(emitSocket = true) {
    if (refIsEndingCall.current) return;
    refIsEndingCall.current = true;

    if (peerConnection.current) {
      try {
        cleanStreams();
        peerConnection.current.close();
        peerConnection.current = null;
        setRemoteStream(null)
        setLocalStream(null)
        setInCall(false);
        refEuQuemLigou.current = false;
        setConnectionState(null)

        if (emitSocket) {
          socket.current.emit('endCall', { to: refIdOther.current });
        }

        if (refCallBackEndCall.current) {
          refCallBackEndCall.current();
        }
      } catch (error) {
        throw new Error('Erro ao finalizar chamada: ' + error)
      } finally {
        setTimeout(() => { refIsEndingCall.current = false; }, 300);
      }
    } else {
      refIsEndingCall.current = false;
    }
  }



  async function callAnswerd(data) {
    if (!peerConnection.current) {
      await configFramesAndWebrtc();
    }

    if (data.newID)
      refQuemLiga.current = data.newID;

    if (peerConnection.current.signalingState !== 'have-local-offer') return;

    await peerConnection.current.setRemoteDescription(new refRTCSessionDescription.current(data.answer));

    if (remoteCandidatesQueue.current.length > 0) {
      for (const queued of remoteCandidatesQueue.current) {
        try {
          await peerConnection.current.addIceCandidate(queued);
        } catch (error) {
          console.log(`flush error [${error}]:`);
        }
      }
      remoteCandidatesQueue.current = [];
    }
  }



  async function acceptACall() {
    try {

      await configFramesAndWebrtc();

      setCallingme(false)

      let _dataCalling = dataCalling.current;

      if (refIsMobile.current && refStorageLib.current) {
        if (!_dataCalling) {
          _dataCalling = JSON.parse(await refStorageLib.current.getItem('@offer'));
        }
        await refStorageLib.current.removeItem('@offer');
      }

      refQuemRecebe.current = _dataCalling.from;

      refIdOther.current = _dataCalling.from;


      const data = _dataCalling;

      if (data.offer) {
        await peerConnection.current.setRemoteDescription(new refRTCSessionDescription.current(data.offer))

        if (remoteCandidatesQueue.current.length > 0) {
          for (const queued of remoteCandidatesQueue.current) {
            try {
              await peerConnection.current.addIceCandidate(queued);
            } catch (error) {
              console.log(`flush error acceptACall [${error}]:`);
            }
          }
          remoteCandidatesQueue.current = [];
        }

        const answer = await peerConnection.current.createAnswer();

        await peerConnection.current.setLocalDescription(answer);

        socket.current.emit("answerCall", {
          to: refQuemRecebe.current,
          answer: answer,
          myID: refMyID.current
        })
      }
      setInCall(true);
      if (refCallBackInitCall.current) {
        refCallBackInitCall.current();
      }
    } catch (error) {
      throw new Error('Erro acceptACall ' + error)
    }
  }



  //Only web
  async function takeRemotePictures(videoW, videoH, remoteVideoRef) {
    try {
      if (refIsMobile.current) return () => alert('Funcionalidade disponível apenas para a versão web');

      const blob = await getBlobFromVideo(videoW, videoH, remoteVideoRef);
      const base64 = await blobToBase64(blob)

      if (base64) return base64;

      return false;
    } catch (error) {
      throw new Error('takeRemotePictures Error: ' + error)
    }
  }



  async function readQrCodeRemote(videoW, videoH, remoteVideoRef) {
    try {
      if (!refQrCodeDecoder.current) return alert('QrCodeDecoder not injected as dependencie');

      const dataURL = await getDataUrlFromVideo(videoW, videoH, remoteVideoRef);
      const qr = new refQrCodeDecoder.current();
      const result = await qr.decodeFromImage(dataURL)
      if (result) {
        return result.data;
      }

      return false;
    } catch (error) {
      throw new Error('readQrCodeRemote Error: ' + error)
    }

  }


  async function blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  async function getBlobFromVideo(videoW, videoH, remoteVideoRef) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = videoW;
    canvas.height = videoH;
    ctx.drawImage(remoteVideoRef.current, 0, 0);
    return new Promise((res, rej) => {
      canvas.toBlob(res, 'image/jpeg');
    });
  }



  async function getDataUrlFromVideo(videoW, videoH, remoteVideoRef) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = videoW;
    canvas.height = videoH;
    ctx.drawImage(remoteVideoRef.current, 0, 0);
    return new Promise((res, rej) => {
      res(canvas.toDataURL())
    });
  }



  return {
    bootstrap,
    mySocketID,
    remoteStream,
    localStream,
    callingme,
    inCall,
    callUser,
    acceptACall,
    endCall,
    readQrCodeRemote,
    takeRemotePictures,
    refuseCall,
    socketInstance,
    connectionState
  }
}


export default useVideoChat;